<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'ACCUMULATORS'" [breadcrumb]="''" [count]="count"
    icon="fa-layer-plus">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="accumulatorGridAdvancedSwitch" [storageKey]="'accumulator-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
            [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
            [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
            [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced"
            [group]="view.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
            (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-ACCUMULATORS' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="name" [width]="25" title="{{ 'NAME' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="startDate" title="{{ 'EFFECTIVE-DATE' | translate }}" [width]="20" filter="date"
                format="{0:d}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-center">{{ intl.formatDate(intl.parseDate(dataItem.startDate), "d") }}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="description" [width]="30" title="{{ 'DESCRIPTION' | translate }}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span title="{{dataItem.description}}">{{dataItem.description | truncate: 100 }}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="maxUnits" [width]="15" title="{{ 'MAX-UNITS' | translate }}" filter="numeric"
                format="n0">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-right">{{dataItem.maxUnits}}</div>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="maxAmount" [width]="15" title="{{ 'MAX-AMOUNT' | translate }}" filter="numeric"
                format="n2">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-right">{{dataItem.maxAmount | number: '1.2-2'}}</div>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="frequency.displayName" [width]="15" title="{{ 'FREQUENCY' | translate }}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-center">{{dataItem.frequency.displayName}}</div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="duration" [width]="15" title="{{ 'DURATION' | translate }}" filter="numeric"
                format="n0">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="text-right">{{dataItem.duration}}</div>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="validateMaximum" [width]="10"
                title="{{ 'ACCUMULATOR-VALIDATE-MAXIMUM' | translate }}" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.validateMaximum" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="allowNonConsecutive" [width]="10"
                title="{{ 'ACCUMULATOR-ALLOW-NON-CONSECUTIVE' | translate }}" filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.allowNonConsecutive" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="enabled" [width]="10" title="{{ 'ENABLED' | translate }}"
                filter="boolean">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.enabled" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="15" title="{{ 'LAST-MODIFIED-BY' | translate }}">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedOn" [width]="15" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}"></kendo-grid-column>
            <kendo-grid-command-column [width]="15" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-accumulator-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-accumulator-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedAccumulator.name}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>